import { ToastContainer, cssTransition } from 'react-toastify';
import { Check, CircleAlert, Info, TriangleAlert } from 'lucide-react';
import 'react-toastify/dist/ReactToastify.css';

// Drops in from above and fades out; the motion lives in the CSS (.mt-toast-in / .mt-toast-out)
const Drop = cssTransition({ enter: 'mt-toast-in', exit: 'mt-toast-out' });

const ICONS = { success: Check, error: CircleAlert, warning: TriangleAlert, info: Info, default: Info };

// The status disc before the message: green for done, red for a failure, amber for a warning, gray otherwise
const ToastIcon = ({ type }) => {
  const Icon = ICONS[type] || Info;
  return (
    <span className={`mt-toast__icon mt-toast__icon--${type}`}>
      <Icon aria-hidden="true" />
    </span>
  );
};

/**
 * The app's notifications, on the card language of the redesign: a white card with a hairline and the overlay
 * shadow, a status disc, the message and any action (Desfazer). No progress bar; a hover or a touch holds it, and
 * a swipe dismisses it. Each toast carries .mt-root for the tokens (the container sits outside the page's root).
 */
export const Notification = () => {
  return (
    <ToastContainer
      className="mt-toasts"
      toastClassName="mt-root mt-toast"
      position="top-center"
      autoClose={5000}
      hideProgressBar
      closeButton={false}
      newestOnTop
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      transition={Drop}
      icon={ToastIcon}
    />
  );
};
